<template>
  <div class="form-group">
    <button
      v-if="!active"
      @click.prevent="toggleInput"
      class="form-control text-left"
      type="button"
      tabindex="0">
      <i
        v-if="ico"
        :class="ico"
        class="fa"></i> {{ placeholder }}
    </button>
    <div v-if="active">
      <div class="pos-rel">
        <input
          v-model="search"
          :aria-controls="name + '-list-box'"
          @keydown="onKeyDown"
          @input="onChange"
          :name="name"
          maxlength="122"
          autocomplete="off"
          class="form-control"
          type="text"
          ref="search"
          aria-autocomplete="list"
          tabindex="0"
          placeholder="" />
          <button
            @click="toggleInput"
            type="button"
            class="close btn-abs-close">
            <i class="fa fa-close"></i>
          </button>
      </div>
      <small>
        Digite 3 ou mais caracteres
      </small>
    </div>
  </div>
</template>

<script>
import debounce from '@/utils/debounce'
import replaceSpecialChars from '@/filters/replaceSpecialChars'

export default {
  props: {
    ico: {
      type: String
    },
    list: {
      type: Array,
      default: () => []
    },
    listKey: {
      type: String,
      default: () => ''
    },
    name: {
      type: String,
      default: () => ''
    },
    placeholder: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      search: null,
      searchList: [],
      active: false
    }
  },
  mounted () {
    this.setSearchList(this.list)
  },
  watch: {
    list (data) {
      this.setSearchList(data)
    }
  },
  methods: {
    setSearchList (list) {
      if ( list.length > 0 ) {
        this.$set(this, 'searchList', list)
      }
    },
    toggleInput () {
      this.active = !this.active
      if (this.active) {
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      }
    },
    onChange: debounce(function (event) {
      if (event.target.value.length >= 3) {
        this.handleSearch()
      }

      if (event.target.value.length === 0) {
        this.$emit('handleInput', this.searchList)
      }
    }, 400),
    onKeyDown (e) {
      const key = e.keyCode

      switch (key) {
        case 13: // ENTER
          e.preventDefault()
        break

        case 27: // ESC
          this.clearSearch()
          e.preventDefault()
        break
      }
    },
    clearSearch () {
      this.toggleInput()
      this.search = null
      this.$emit('handleInput', this.searchList)
    },
    handleSearch () {
      const source = [ ...this.searchList ]
      const sourceKeys = this.listKey.split(',')
      const search = this.search

      const searchList = source.filter(item =>
        sourceKeys.some(key => {
          return (Object.prototype.hasOwnProperty.call(item, key)
            && (item[key] && String(replaceSpecialChars(item[key]).toUpperCase()).indexOf(replaceSpecialChars(search).toUpperCase()) !== -1))
        })
      )

      this.$emit('handleInput', searchList)
    }
  }
}
</script>
